<template>
  <div :class="{ 'score-bubble': true, [lead.SCORE]: true }" @click="openPopup" v-click-outside="closePopup">
    <template v-if="lead.SCORE == 'hot'"><img src="../assets/hot.png" /> Hot</template>
    <template v-if="lead.SCORE == 'warm'"><img src="../assets/warm.png" /> Warm</template>
    <template v-if="lead.SCORE == 'cool'"><img src="../assets/cool.png" /> Cool</template>
    <template v-if="lead.SCORE == 'dead'"><img src="../assets/dead.png" /> Dead</template>
    <div :class="{ 'score-popup-chooser': true, [lead.SCORE]: true }" v-if="isOpen">
      <div class="score-popup-chooser-item">
        <img :style="{ opacity: lead.SCORE == 'hot' ? '1' : '0' }" src="../assets/checkmark.svg" />
        <div class="bubble hot" @click.stop="setScore('hot')"><img src="../assets/hot.png" /> Hot</div>
      </div>
      <div class="score-popup-chooser-item">
        <img :style="{ opacity: lead.SCORE == 'warm' ? '1' : '0' }" src="../assets/checkmark.svg" />
        <div class="bubble warm" @click.stop="setScore('warm')"><img src="../assets/warm.png" /> Warm</div>
      </div>
      <div class="score-popup-chooser-item">
        <img :style="{ opacity: lead.SCORE == 'cool' ? '1' : '0' }" src="../assets/checkmark.svg" />
        <div class="bubble cool" @click.stop="setScore('cool')"><img src="../assets/cool.png" /> Cool</div>
      </div>
      <div class="score-popup-chooser-item">
        <img :style="{ opacity: lead.SCORE == 'dead' ? '1' : '0' }" src="../assets/checkmark.svg" />
        <div class="bubble dead" @click.stop="setScore('dead')"><img src="../assets/dead.png" /> Dead</div>
      </div>
    </div>
  </div>
</template>

<script>
import useLeadMutate from '../composables/useLeadMutate';
import useAlerts from '../composables/useAlerts';

export default {
  name: 'ScoreSelector',
  props: {
    lead: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { updateLead } = useLeadMutate();
    const { addAlert } = useAlerts();
    return { updateLead, addAlert };
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    async setScore(score) {
      const oldScore = this.lead.SCORE;
      this.lead.SCORE = score;
      this.isOpen = false;

      // Only update if the score actually changed
      if (oldScore !== score) {
        try {
          await this.updateLead(this.lead.LEADID, { SCORE: score });
          this.addAlert('Lead score updated', 'low', 2);
        } catch (error) {
          console.error('Failed to update lead score:', error);
          // Revert to old score if update fails
          this.lead.SCORE = oldScore;
          this.addAlert('Failed to update lead score', 'high', 3);
        }
      }
    },
    openPopup() {
      this.isOpen ? null : (this.isOpen = true);
    },
    closePopup() {
      this.isOpen = false;
    },
  },
};
</script>

<style scoped lang="scss">
.score-bubble {
  padding: 0.3rem 0.6rem 0.3rem 0.5rem;
  border-radius: $borderRadius4;
  font-weight: 600;
  text-wrap: nowrap;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  overflow: visible;
  cursor: pointer;

  img {
    width: 1.1rem;
    height: 1.1rem;
    margin-right: 0.3rem;
  }

  &.hot {
    background: $hotBackgroundColor;
    color: $hotTextColor;
  }
  &.warm {
    background: $warmBackgroundColor;
    color: $warmTextColor;
  }
  &.cool {
    background: $coldBackgroundColor;
    color: $coldTextColor;
  }
  &.dead {
    background: $deadBackgroundColor;
    color: $deadTextColor;
  }

  .score-popup-chooser {
    position: absolute;
    box-shadow: $shadow1;
    z-index: 100;
    top: 0;
    left: -2.68rem;
    padding: 0.75rem 0.75rem;
    background: white;
    overflow: visible;
    border-radius: $borderRadius4;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    align-items: flex-start;
    justify-content: flex-start;
    cursor: default;

    &.hot {
      top: -0.7rem;
    }
    &.warm {
      top: -2.9rem;
    }
    &.cool {
      top: -5.1rem;
    }
    &.dead {
      top: -7.3rem;
    }
    .score-popup-chooser-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      gap: 0.5rem;

      img {
        width: 1.1rem;
        height: 1.1rem;
      }

      .bubble {
        padding: 0.3rem 0.6rem 0.3rem 0.5rem;
        border-radius: $borderRadius4;
        font-weight: 600;
        text-wrap: nowrap;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        cursor: pointer;

        &.hot {
          background: $hotBackgroundColor;
          color: $hotTextColor;
        }
        &.warm {
          background: $warmBackgroundColor;
          color: $warmTextColor;
        }
        &.cool {
          background: $coldBackgroundColor;
          color: $coldTextColor;
        }
        &.dead {
          background: $deadBackgroundColor;
          color: $deadTextColor;
        }
      }
    }
  }
}
</style>
